import { VenueGetShopifyStoreConnectFilter } from '../../graphql/API';
import { venueFetchLatestShopifyProducts } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueFetchLatestShopifyProductsApi = async (
  filter: VenueGetShopifyStoreConnectFilter,
): Promise<Record<string, boolean>> => {
  const result = await executeGql(venueFetchLatestShopifyProducts, { filter });
  return processGqlResult('venueFetchLatestShopifyProducts', result);
};
